<template>
  <div class="mobile-platform" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { is_display_mobile } from './index'

  export default {
    name: 'DisplayTypeOnlyMobile',
    computed: {
      ...mapState(['isMobile', 'isTurbo']),
      show() {
        return is_display_mobile(this.isMobile, this.isTurbo)
      },
    },
  }
</script>
